import HomePage from '@/features/home/presentation/page/HomePage';
import NewHomePage from '@/features/newHome/presentation/page/NewHomePage';
import { useMultivariateExperiment } from '@/shared/features/multivariateexperiment/presentation/hooks/useMultivariateExperiment';

export default function ConditionalHomePage() {
  const { homePageVariant: variant } = useMultivariateExperiment();
  return (variant === 'V2' || variant === 'V3' || variant === 'V4' || variant === 'V5' || variant === 'V6' || variant === 'V7') ? <NewHomePage /> : <HomePage />;
}
